import cookie from 'js-cookie'
import toast from '../utils/toast'
import {
  /**
   * @description Actions for login and logout requests
   */
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST
} from '../constants'

import { auth } from '../api'
import { history } from '../store'
import { removeToken } from '../utils'

/**
 * @description Dispatches action that should authenticate a user
 * @param {object} credentials - Object data with form values {@user, @password and @code}
 * @returns {object} The post data with the action type and the new state values
 */
export const login = ({ token, redirectTo }) => {
  return async (dispatch) => {
    try {
      /**
       * @description Wait for the promise to be resolved
       */
      const login = await auth.login({ token })

      /**
       * @description Triggers the action when a promise is resolved and assigns the authentication and token values
       */
      await dispatch({
        type: LOGIN_SUCCESS,
        isAuthenticated: true,
        authToken: login.data
      })

      /**
       * @description Saves the token in the localStorage
       */

      localStorage.setItem('authToken', JSON.stringify(login.data))

      cookie.set('authToken', JSON.stringify(login.data), {
        expires: 30,
        path: '/'
      })
      /**
       * @description Redirects the user to the host or route
       */
      redirectTo
        ? window.location.replace(
            `${redirectTo}/?authToken=${JSON.stringify(login.data)}`
          )
        : history.push('/clubs')
    } catch (e) {
      /**
       * @description Triggers the action when a promise fails and assigns the authentication to false
       */
      dispatch({
        type: LOGIN_FAILURE,
        isAuthenticated: false
      })

      toast({
        title: e.response.data.message,
        type: e.response.data.type
      })
    }
  }
}

/**
 * @description Dispatches action that should unauthenticate a user
 * @returns {object} The post data with the action type and the new state values
 */
export const logout = (fn = () => {}) => {
  return async (dispatch) => {
    try {
      /**
       * @description Triggers action when a promise is resolved and assigns the authentication values to false
       */
      dispatch({
        type: LOGOUT_REQUEST,
        isAuthenticated: false
      })

      /**
       * @description Removes the token in the localStorage
       */
      removeToken()

      fn()
    } catch (e) {
      /**
       * @description Removes the token in the localStorage
       */
      removeToken()

      /**
       * @description Redirects to the login page when the user is unauthenticated
       */
      history.push('/login')
    }
  }
}
